import request from '@/utils/request';

// 获取员工权限
export const currentEmployeeRoleInfo = (data: any): any =>
  request({
    url: '/pc/employeeRole/currentemployeeRoleInfo',
    data: data
  })

// 订单列表
export const orderList = (data: any): any =>
	request({
		url: '/pc/order/orderQueryList',
		data: data
	})

// 订单列表
export const memberOrderList = (data: any): any =>
	request({
		url: '/pc/member/memberOrderList',
		data: data
	})

// 订单详情
export const orderInfo = (data: any): any =>
	request({
		url: '/pc/order/orderDetail',
		data: data
	})

// 订单回执
export const orderReceipt = (data: any): any =>
	request({
		url: '/pc/order/receipt',
		data: data
	})

export const productNetIncomeList = (data: any): any =>
	request({
		url: '/pc/order/productNetIncomeList',
		data: data
	})



// 查看物流
export const lookExpress = (data: any): any =>
	request({
		url: '/pc/order/lookExpress',
		data: data
	})

//订单审核人流程
export const orderCheck = (data: any): any =>
	request({
		url: '/pc/order/orderRecordList',
		data: data
	})

// 代理订单
export const agencyOrderList = (data: any): any =>
	request({
		url: '/pc/order/agentOrderList',
		data: data
	})

// 代理订单_待审核订单
export const getAgentCheckOrderList = (data: any): any =>
	request({
		url: '/pc/order/checkOrderList',
		data: data
	})

//公司审核订单-通过
export const checkBackendAgentOrder = (data: any): any =>
	request({
		url: '/pc/order/checkOrderPass',
		data: data
	})
//公司审核订单-驳回
export const checkBackendAgentOrderReject = (data: any): any =>
	request({
		url: '/pc/order/checkOrderReject',
		data: data
	})

//产品订单
export const getAgentProductOrderList = (data: any): any =>
	request({
		url: '/pc/order/productWaitSendOrderStatisticList',
		data: data
	})

//产品订单_查看详细
export const getAgentProductOrderDetail = (data: any): any =>
	request({
		url: '/pc/order/productOrderList',
		data: data
	})

//代理订单_审核记录
export const getAgentOrderCheckRecordList = (data: any): any =>
	request({
		url: '/pc/order/checkStatisByProductList',
		data: data
	})

//代理订单_审核记录_查看详情
export const getAgentCheckOrderRecordDetail = (data: any): any =>
	request({
		url: '/agent/check/order/detail',
		data: data
	})

// 代理订单——产品记录
export const getAgentProductRecordList = (data: any): any =>
	request({
		url: '/agent/product/recordlist',
		data: data
	})

// 代理订单_产品规格详情列表
export const getAgentProductSkuDetailList = (data: any): any =>
	request({
		url: '/agent/product/sku/list',
		data: data
	})

//代理订单_产品规格订单列表
export const getAgentProductSkuOrderList = (data: any): any =>
	request({
		url: '/agent/product/sku/order/list',
		data: data
	})

// 代理订单(商品汇总)
export const getAgentOrderSummary = (data: any): any =>
	request({
		url: '/pc/order/checkOrderProductCollectList',
		data: data
})

// 导出报表
export const getReportForms = (data: any): any =>
	request({
		url: '/order/excel',
		data: data
	})

// 获取表单地址
export const getLogisticsExcelUrl = (data: any): any =>
	request({
		url: '/logistics/url',
		data
	})


//审核记录
export const checkStatisByMemberList = (data: any): any =>
	request({
		url: '/pc/order/checkStatisByMemberList',
		data: data
	})


// 修改收货地址
export const ordereditReceiveAddress = (data: any): any =>
	request({
		url: '/pc/order/editReceiveAddress',
		data: data
	})



// 地址智能识别
export const addresssmartparse = (data: any): any =>
	request({
		url: '/address-smart-parse',
		data: data
	})



// 汇总规格列表
export const ordercheckOrderProductCollectSpecList = (data: any): any =>
	request({
		url: '/pc/order/checkOrderProductCollectSpecList',
		data: data
	})


// 导入物流播报
export const orderExpressBroadcastimport = (data: any): any =>
	request({
		url: '/pc/orderExpressBroadcast/import',
		data: data
	})
// 物流播报列表
export const orderExpressBroadcastlist = (data: any): any =>
	request({
		url: '/pc/orderExpressBroadcast/list',
		data: data
	})

// 分销员售后统计
export const orderSupportmemberOrderSupportStatistic = (data: any): any =>
	request({
		url: '/pc/orderSupport/memberOrderSupportStatistic',
		data: data
	})

// 分销员售后统计明细
export const orderSupportmemberOrderSupportStatisticDetail = (data: any): any =>
	request({
		url: '/pc/orderSupport/memberOrderSupportStatisticDetail',
		data: data
	})


// 商品售后统计
export const orderSupportorderSupportProductStatistic = (data: any): any =>
	request({
		url: '/pc/orderSupport/orderSupportProductStatistic',
		data: data
	})

// 商品售后统计明细
export const orderSupportorderSupportProductStatisticDetail = (data: any): any =>
	request({
		url: '/pc/orderSupport/orderSupportProductStatisticDetail',
		data: data
	})


// 获取小程序二维码
export const mallgetQrCode = (data: any): any =>
	request({
		url: '/pc/mall/getQrCode',
		data: data
	})

// 开启/关闭允许售后
export const orderisForceAllowSupport = (data: any): any =>
	request({
		url: '/pc/order/isForceAllowSupport',
		data: data
	})

// 修改客服备注
export const ordereditCustomerServiceRemark = (data: any): any =>
	request({
		url: '/pc/order/editCustomerServiceRemark',
		data: data
	})
// 同步到供应商后台发货的订单截止日期
export const ordersyncOrderToProviderConfig = (data: any): any =>
	request({
		url: '/pc/order/syncOrderToProviderConfig',
		data: data
	})




// 产品发货管理-列表
export const productSendlist = (data: any): any =>
	request({
		url: '/pc/order/productSend/list',
		data: data
	})
// 产品发货管理-导入发货
export const productSendsendOrderDetailImport = (data: any): any =>
	request({
		url: '/pc/order/productSend/sendOrderDetailImport',
		data: data
	})


// 产品发货管理-查看详情
export const productSendorderDetailList = (data: any): any =>
	request({
		url: '/pc/order/productSend/orderDetailList',
		data: data
	})
// 产品发货管理-发货
export const productSendsend = (data: any): any =>
	request({
		url: '/pc/order/productSend/send',
		data: data
	})

// 关闭订单
export const orderclose = (data: any): any =>
	request({
		url: '/pc/order/close',
		data: data
	})


// 产品发货管理-返回待发货-导入列表
export const productSendsendReturnImportList = (data: any): any =>
	request({
		url: '/pc/order/productSend/sendReturnImportList',
		data: data
	})
// 产品发货管理-返回待发货-导入
export const productSendsendReturnImport = (data: any): any =>
	request({
		url: '/pc/order/productSend/sendReturnImport',
		data: data
	})
// 产品发货管理-返回待发货-返回待发货
export const productSendsendReturn = (data: any): any =>
	request({
		url: '/pc/order/productSend/sendReturn',
		data: data
	})




// 关闭订单-导入 
export const ordercloseImport = (data: any): any =>
	request({
		url: '/pc/order/closeImport',
		data: data
	})
// 产品发货管理-商品发货进度汇总
export const productSendsentCollectList = (data: any): any =>
	request({
		url: '/pc/order/productSend/sentCollectList',
		data: data
	})

// 物流查询统计-订购服务
export const expressQueryOrderServicePageInfo = (data: any): any =>
	request({
		url: '/pc/expressquery/expressqueryorderservicepageinfo',
		data: data
	})
// 物流查询统计-确认购买套餐
export const applyPayExpressQueryPackage = (data: any): any =>
	request({
		url: '/pc/expressquery/applypayexpressquerypackage',
		data: data
	})
// 物流查询统计-获取支付结果
export const buyExpressQueryPackageResult = (data: any): any =>
	request({
		url: '/pc/expressquery/buyexpressquerypackageResult',
		data: data
	})
// 物流查询统计
export const expressQueryStatistic = (data: any): any =>
	request({
		url: '/pc/expressquery/expressquerystatistic',
		data: data
	})
// 物流查询统计-订购记录
export const expressQueryOrderPageList = (data: any): any =>
	request({
		url: '/pc/expressquery/expressqueryorderpagelist',
		data: data
	})

// 审核记录-支付记录（按下单人统计）
export const orderpayStatisByMemberList = (data: any): any =>
	request({
		url: '/pc/order/payStatisByMemberList',
		data: data
	})
// 审核记录-支付记录-详情列表
export const orderpayOrderList = (data: any): any =>
	request({
		url: '/pc/order/payOrderList',
		data: data
	})
	
// 商品结算
export const productSettlementlist = (data: any): any =>
request({
	url: '/pc/order/productSettlement/list',
	data: data
})
// 复制发货情况
export const productSendcopySendInfo = (data: any): any =>
request({
	url: '/pc/order/productSend/copySendInfo',
	data: data
})


// 线下退款
export const ordercloseWithoutRefund = (data: any): any =>
request({
	url: '/pc/order/closeWithoutRefund',
	data: data
})


// 商品临时下单二维码列表(散单加单)
export const tempAddOrderQRCodelist = (data: any): any =>
request({
	url: '/pc/product/tempAddOrderQRCode/list',
	data: data
})
// 商品临时下单二维码添加(散单加单)
export const tempAddOrderQRCodeadd = (data: any): any =>
request({
	url: '/pc/product/tempAddOrderQRCode/add',
	data: data
})
// 商品临时下单二维码修改(散单加单)
export const tempAddOrderQRCodemodify = (data: any): any =>
request({
	url: '/pc/product/tempAddOrderQRCode/modify',
	data: data})
// 商品临时下单二维码详情(散单加单)
export const producttempAddOrderQRCodedetail = (data: any): any =>
request({
	url: '/pc/product/tempAddOrderQRCode/detail',
	data: data

})

// 商品临时下单-单笔订单起购数量-信息(散单加单)
export const tempAddOrderminBuyCountInfo = (data: any): any =>
request({
	url: '/pc/product/tempAddOrder/minBuyCount/Info',
	data: data
})

// 商品临时下单-单笔订单起购数量-修改(散单加单)
export const tempAddOrderminBuyCountmodify = (data: any): any =>
request({
	url: '/pc/product/tempAddOrder/minBuyCount/modify',
	data: data
})
// 供货商商品结算导出记录
export const settlementExportRecordlist = (data: any): any =>
request({
	url: '/pc/provider/settlementExportRecord/list',
	data: data
})
// 散单加单-汇总数据(GET为导出)
export const tempAddOrderstatislist = (data: any): any =>
request({
	url: '/pc/order/tempAddOrder/statis/list',
	data: data
})
// 散单加单-订单明细(GET为导出)
export const tempAddOrderdetaillist = (data: any): any =>
request({
	url: '/pc/order/tempAddOrder/detail/list',
	data: data
})

// 导入商品规格编码数据
export const productproductSpecNoImport = (data: any): any =>
request({
	url: '/pc/product/productSpecNoImport',
	data: data
})



// 获取物流结算模板详情
export const freightSettlementTemplatefreightSettlementTemplateInfo = (data: any): any =>
request({
	url: '/pc/freightSettlementTemplate/freightSettlementTemplateInfo',
	data: data
})
// 获取物流结算模板
export const freightSettlementTemplatefreightSettlementTemplateList = (data: any): any =>
request({
	url: '/pc/freightSettlementTemplate/freightSettlementTemplateList',
	data: data
})
// 修改为其他物流结算模板
export const productproductChangeFreightSettlementTemplate = (data: any): any =>
request({
	url: '/pc/product/productChangeFreightSettlementTemplate',
	data: data
})
// 物流结算模板保存
export const freightSettlementTemplatefreightSettlementTemplateSave = (data: any): any =>
request({
	url: '/pc/freightSettlementTemplate/freightSettlementTemplateSave',
	data: data
})
// 物流结算模板修改记录
export const freightSettlementTemplatefreightSettlementTemplateRecord = (data: any): any =>
request({
	url: '/pc/freightSettlementTemplate/freightSettlementTemplateRecord',
	data: data
})


// 商品结算-刷新结算运费
export const productSettlementrefreshSettleFreightMoney = (data: any): any =>
request({
	url: '/pc/order/productSettlement/refreshSettleFreightMoney',
	data: data
})
// 商品结算-获取最近一次刷新时间
export const productSettlementcalculateInfo = (data: any): any =>
request({
	url: '/pc/order/productSettlement/calculateInfo',
	data: data
})



// 财务-订单结算-未结算列表
export const orderSettleunsettledlist = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/unsettled/list',
	data: data
})
// 财务-订单结算-审核中已结算列表
export const orderSettlerecordlist = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/record/list',
	data: data
})
// 财务-订单结算-结算首款验证
export const orderSettlesettleFirstverify = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/settleFirst/verify',
	data: data
})
// 财务-订单结算-结算首款未签收订单列表
export const orderSettlesettleFirstunsignedOrderDetailList = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/settleFirst/unsignedOrderDetailList',
	data: data
})
// 财务-订单结算-结算首款信息
export const orderSettlesettleFirstinfo = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/settleFirst/info',
	data: data
})
// 财务-订单结算-结算首款
export const orderSettlesettleFirst = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/settleFirst',
	data: data
})
// 财务-订单结算-结算尾款信息
export const orderSettlesettleLastinfo = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/settleLast/info',
	data: data
})
// 财务-订单结算-结算尾款
export const orderSettlesettleLast = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/settleLast',
	data: data
})
// 财务-订单结算-订单明细列表
export const orderSettleorderDetailList = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/orderDetailList',
	data: data
})
// 财务-订单结算-审核结算首款
export const orderSettlecheckSettleFirst = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/checkSettleFirst',
	data: data
})
// 财务-订单结算-审核结算尾款
export const orderSettlecheckSettleLast = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/checkSettleLast',
	data: data
})
// 财务-订单结算-操作日志
export const orderSettleoperateRecordlist = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/operateRecord/list',
	data: data
})

// 财务-订单结算-跟单售后审核结算首款
export const orderSettleFollowOrderAndAfterSaleCheckSettleFirst = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/FollowOrderAndAfterSaleCheckSettleFirst',
	data: data
})
// 财务-订单结算-跟单售后审核结算尾款
export const orderSettleFollowOrderAndAfterSaleCheckSettleLast = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/FollowOrderAndAfterSaleCheckSettleLast',
	data: data
})
// 财务-订单结算-明细导出-参数缓存 
export const orderSettledetailexportparamCache = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/detail/export/paramCache',
	data: data
})




// 结算信息
export const orderSettlesettleInfo = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/settleInfo',
	data: data
})
// 审核结算
export const orderSettlecheckSettle = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/checkSettle',
	data: data
})
// 跟单售后审核结算
export const orderSettleFollowOrderAndAfterSaleCheckSettle = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/FollowOrderAndAfterSaleCheckSettle',
	data: data
})
// 审核驳回
export const orderSettlecheckSettleReject = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/checkSettleReject',
	data: data
})
// 售后明细列表
export const orderSettlesupportList = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/supportList',
	data: data
})


// -订单结算-结算时间
export const orderSettlesettleTime = (data: any): any =>
request({
	url: '/pc/finance/orderSettle/settleTime',
	data: data
})




// 获取下单人信息
export const orderImportmemberInfo = (data: any): any =>
request({
	url: '/pc/orderImport/memberInfo',
	data: data
})
// 导入订单
export const orderImportimport = (data: any): any =>
request({
	url: '/pc/orderImport/import',
	data: data
})
// 获取导入处理结果
export const orderImportgetImportDealResult = (data: any): any =>
request({
	url: '/pc/orderImport/getImportDealResult',
	data: data
})
// 取消订单
export const orderImportcancelOrder = (data: any): any =>
request({
	url: '/pc/orderImport/cancelOrder',
	data: data
})
// 记录初始化信息
export const orderImportrecordInit = (data: any): any =>
request({
	url: '/pc/orderImport/recordInit',
	data: data
})
// 记录列表
export const orderImportrecordlist = (data: any): any =>
request({
	url: '/pc/orderImport/recordlist',
	data: data
})

// 商品日常消耗统计-列表
export const productConsumeStatislist = (data: any): any =>
request({
	url: '/pc/productConsumeStatis/list',
	data: data
})
// 商品日常消耗统计-编辑
export const productConsumeStatisedit = (data: any): any =>
request({
	url: '/pc/productConsumeStatis/edit',
	data: data
})
// 商品日常消耗统计-删除
export const productConsumeStatisdelete = (data: any): any =>
request({
	url: '/pc/productConsumeStatis/delete',
	data: data
})
// 商品日常消耗统计-导入
export const productConsumeStatisimport = (data: any): any =>
request({
	url: '/pc/productConsumeStatis/import',
	data: data
})


// 财务-订单结算-核实已打款
export const orderSettletransferVerify = (data: any): any =>
	request({
		url: '/pc/finance/orderSettle/transferVerify',
		data: data
	})
// 财务-订单结算-已线下打款
export const orderSettleofflineTransfer = (data: any): any =>
	request({
		url: '/pc/finance/orderSettle/offlineTransfer',
		data: data
	})





// 自营品牌列表
export const ownBrandlist = (data: any): any =>
request({
	url: '/pc/ownBrand/list',
	data: data
})
// 自营品牌删除
export const ownBranddelete = (data: any): any =>
request({
	url: '/pc/ownBrand/delete',
	data: data
})
// 自营品牌保存
export const ownBrandsave = (data: any): any =>
request({
	url: '/pc/ownBrand/save',
	data: data
})
// 自营品牌详情 
export const ownBranddetail = (data: any): any =>
request({
	url: '/pc/ownBrand/detail',
	data: data
})
// 自营品牌轮播图列表 
export const ownBrandCarousellist = (data: any): any =>
request({
	url: '/pc/ownBrandCarousel/list',
	data: data
})
// 自营品牌轮播图保存
export const ownBrandCarouselsave = (data: any): any =>
request({
	url: '/pc/ownBrandCarousel/save',
	data: data
})

// 自营品牌商品列表
export const ownBrandProductlist = (data: any): any =>
request({
	url: '/pc/ownBrandProduct/list',
	data: data
})
// 自营品牌商品删除
export const ownBrandProductdelete = (data: any): any =>
request({
	url: '/pc/ownBrandProduct/delete',
	data: data
})
// 自营品牌商品保存
export const ownBrandProductsave = (data: any): any =>
request({
	url: '/pc/ownBrandProduct/save',
	data: data
})
// 自营品牌商品筛选列表
export const ownBrandProductfilterBoxList = (data: any): any =>
request({
	url: '/pc/ownBrandProduct/filterBoxList',
	data: data
})


// 商品一级类目列表
export const productproductFirstClassList = (data: any): any =>
request({
	url: '/pc/product/productFirstClassList',
	data: data
})
// 创建类目
export const productproductClassSave = (data: any): any =>
request({
	url: '/pc/product/productClassSave',
	data: data
})
// 删除
export const productproductClassDel = (data: any): any =>
request({
	url: '/pc/product/productClassDel',
	data: data
})
// 商品二级类目列表
export const productproductSecondClassList = (data: any): any =>
request({
	url: '/pc/product/productSecondClassList',
	data: data
})
// 商品三级类目列表
export const productproductThirdClassList = (data: any): any =>
request({
	url: '/pc/product/productThirdClassList',
	data: data
})
// 分类-筛选框列表
export const productClassfilterBoxList = (data: any): any =>
request({
	url: '/pc/productClass/filterBoxList',
	data: data
})
// 获取商品供货商供货价
export const productproductProviderSupplyPrice = (data: any): any =>
request({
	url: '/pc/product/productProviderSupplyPrice',
	data: data
})
// 保存商品供货商供货价
export const productproductProviderSupplyPriceSave = (data: any): any =>
request({
	url: '/pc/product/productProviderSupplyPriceSave',
	data: data
})
// 商品类目-树 
export const productClasslistTree = (data: any): any =>
request({
	url: '/pc/productClass/listTree',
	data: data
})
// 排期商品列表
export const productscheduleProductList = (data: any): any =>
request({
	url: '/pc/product/scheduleProductList',
	data: data
})

// 排期商品审核
export const productscheduleProductCheck = (data: any): any =>
request({
	url: '/pc/product/scheduleProductCheck',
	data: data
})
// 修改商品资质
export const productscheduleProductQualificationEdit = (data: any): any =>
request({
	url: '/pc/product/scheduleProductQualificationEdit',
	data: data
})


// 排期商品资料审核
export const productscheduleProductInfoCheck = (data: any): any =>
request({
	url: '/pc/product/scheduleProductInfoCheck',
	data: data
})
// 排期商品素材审核
export const productscheduleProductMaterialCheck = (data: any): any =>
request({
	url: '/pc/product/scheduleProductMaterialCheck',
	data: data
})
// 排期商品资质审核
export const productscheduleProductAptitudeCheck = (data: any): any =>
request({
	url: '/pc/product/scheduleProductAptitudeCheck',
	data: data
})
// 排期商品物流审核
export const productscheduleProductLogisticsCheck = (data: any): any =>
request({
	url: '/pc/product/scheduleProductLogisticsCheck',
	data: data
})




// 复制订单信息
export const ordercopyOrderInfo = (data: any): any =>
request({
	url: '/pc/order/copyOrderInfo',
	data: data
})
// 物流单号查询订单
export const ordergetOrderNoByExpressNo = (data: any): any =>
request({
	url: '/pc/order/getOrderNoByExpressNo',
	data: data
})